module.exports = __webpack_public_path__ + "static/media/Pool1.799ff359.jpg";